import React from "react";
import {
  Box,
  Container,
  Stack,
  Text,
  Image,
  Flex,
  VStack,
  Heading,
  SimpleGrid,
  StackDivider,
  Center,
  Icon,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useArticleQuery } from "../../graphql";
import { Loader } from "../../components/Loader";
import { MdImage } from "react-icons/md";
import { Img } from "react-image";

export function BlogArticle() {
  const { id } = useParams<{ id: string }>();
  const articleId = parseInt(id);

  const { data, loading } = useArticleQuery({ variables: { id: articleId } });

  if (loading) {
    return <Loader />;
  }

  return (
    <Container maxW={"5xl"}>
      <SimpleGrid
        columns={{ base: 1, lg: 1 }}
        spacing={{ base: 8, md: 8 }}
        py={{ base: 8, md: 8 }}
      >
        <Flex>
          <Img
            src={data?.article?.cover?.url}
            style={{
              height: "100%",
              maxHeight: "500px",
              width: "100%",
              objectFit: "cover",
            }}
            loader={
              <>
                <Center
                  width={"100%"}
                  background="blue.50"
                  color="blue.400"
                  h={{ lg: "500px", base: "350px" }}
                >
                  <Icon as={MdImage} fontSize={50} />
                </Center>
              </>
            }
          />
        </Flex>
        <Stack spacing={{ base: 6, md: 10 }}>
          <Box as={"header"}>
            <Heading
              lineHeight={1.1}
              fontWeight={600}
              fontSize={{ base: "2xl", sm: "4xl", lg: "5xl" }}
            >
              {data.article.title}
            </Heading>
          </Box>

          <Stack
            spacing={{ base: 4, sm: 6 }}
            direction={"column"}
            divider={<StackDivider borderColor={"gray.200"} />}
          >
            <VStack spacing={{ base: 4, sm: 6 }}>
              {/* <Text
                color={useColorModeValue("gray.500", "gray.400")}
                fontSize={"2xl"}
                fontWeight={"300"}
              >
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore
              </Text> */}
              <Text fontSize={"lg"}>
                <p dangerouslySetInnerHTML={{ __html: data.article.body }}></p>
              </Text>
            </VStack>
          </Stack>

          <Stack
            direction="column"
            alignItems="center"
            justifyContent={"center"}
          >
            <Flex>
              <Image
                rounded={"md"}
                alt={"product image"}
                src={"/logo-white.png"}
                fit={"cover"}
                align={"center"}
                w={"100%"}
                h={{ base: "100%", sm: "100px", lg: "100px" }}
              />
            </Flex>
          </Stack>
        </Stack>
      </SimpleGrid>
    </Container>
  );
}
